import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('crm-object-search-query-utilities');